window.ICASE_DEVICE_FINDER_DATA = [
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 18 Series",
    "model": "iPhone 18 Pro Max",
    "url": "/collections/iphone-18-pro-max?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 18 Series",
    "model": "iPhone 18 Pro",
    "url": "/collections/iphone-18-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 17 Series",
    "model": "iPhone 17",
    "url": "/collections/iphone-17?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 17 Series",
    "model": "iPhone 17 Air",
    "url": "/collections/iphone-17-air?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 17 Series",
    "model": "iPhone 17 Pro",
    "url": "/collections/iphone-17-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 17 Series",
    "model": "iPhone 17 Pro Max",
    "url": "/collections/iphone-17-pro-max?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 16 Series",
    "model": "iPhone 16",
    "url": "/collections/iphone-16?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 16 Series",
    "model": "iPhone 16 Plus",
    "url": "/collections/iphone-16-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 16 Series",
    "model": "iPhone 16 Pro",
    "url": "/collections/iphone-16-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 16 Series",
    "model": "iPhone 16 Pro Max",
    "url": "/collections/iphone-16-pro-max?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 15 Series",
    "model": "iPhone 15",
    "url": "/collections/iphone-15?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 15 Series",
    "model": "iPhone 15 Plus",
    "url": "/collections/iphone-15-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 15 Series",
    "model": "iPhone 15 Pro",
    "url": "/collections/iphone-15-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 15 Series",
    "model": "iPhone 15 Pro Max",
    "url": "/collections/iphone-15-pro-max?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 14 Series",
    "model": "iPhone 14",
    "url": "/collections/iphone-14?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 14 Series",
    "model": "iPhone 14 Plus",
    "url": "/collections/iphone-14-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 14 Series",
    "model": "iPhone 14 Pro",
    "url": "/collections/iphone-14-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 14 Series",
    "model": "iPhone 14 Pro Max",
    "url": "/collections/iphone-14-pro-max?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 13 Series",
    "model": "iPhone 13",
    "url": "/collections/for-iphone-13?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 13 Series",
    "model": "iPhone 13 Pro",
    "url": "/collections/for-iphone-13-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 13 Series",
    "model": "iPhone 13 Pro Max",
    "url": "/collections/for-iphone-13-pro-max?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 12 Series",
    "model": "iPhone 12",
    "url": "/collections/iphone-12-12-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 12 Series",
    "model": "iPhone 12 Mini",
    "url": "/collections/iphone-12-mini?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 12 Series",
    "model": "iPhone 12 Pro",
    "url": "/collections/iphone-12-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 12 Series",
    "model": "iPhone 12 Pro Max",
    "url": "/collections/iphone-12-pro-max?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 11 Series",
    "model": "iPhone 11",
    "url": "/collections/iphone-12?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 11 Series",
    "model": "iPhone 11 Pro",
    "url": "/collections/iphone-11-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "iPhone 11 Series",
    "model": "iPhone 11 Pro Max",
    "url": "/collections/iphone-11-pro-max?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "Older iPhone",
    "model": "iPhone SE (2020/2022)",
    "url": "/collections/iphone-se-5g-2022-se-2020?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "Older iPhone",
    "model": "iPhone X / Xs",
    "url": "/collections/iphone-x-xs-case?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Apple",
    "series": "Older iPhone",
    "model": "iPhone Xs Max",
    "url": "/collections/iphone-xs-max?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S26 Ultra",
    "url": "/collections/galaxy-s26-ultra?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S26 Plus",
    "url": "/collections/galaxy-s26-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S26",
    "url": "/collections/galaxy-s26?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S25 Ultra",
    "url": "/collections/galaxy-s25-ultra?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S25 Plus",
    "url": "/collections/galaxy-s25-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S25 Edge",
    "url": "/collections/galaxy-s25-edge?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S25 FE",
    "url": "/collections/galaxy-s25-fe?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S25",
    "url": "/collections/galaxy-s25?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S24 Ultra",
    "url": "/collections/galaxy-s24-ultra?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S24 Plus",
    "url": "/collections/galaxy-s24-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S24 FE",
    "url": "/collections/galaxy-s24-fe?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S24",
    "url": "/collections/galaxy-s24?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S23 Ultra",
    "url": "/collections/for-galaxy-s23-ultra?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S23 Plus",
    "url": "/collections/for-galaxy-s23-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S23 FE",
    "url": "/collections/galaxy-s23fe?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S23",
    "url": "/collections/for-galaxy-s23?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S22 Ultra",
    "url": "/collections/for-galaxy-s22-ultra?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S22 Plus",
    "url": "/collections/for-galaxy-s22-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S22",
    "url": "/collections/for-galaxy-s22?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S21 Ultra",
    "url": "/collections/s21-ultra?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S21 Plus",
    "url": "/collections/s21-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S21 FE",
    "url": "/collections/galaxy-s21-fe?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S21",
    "url": "/collections/s21?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S20 Ultra",
    "url": "/collections/for-galaxy-s20-ultra?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S20 Plus",
    "url": "/collections/galaxy-s20-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S20 FE",
    "url": "/collections/galaxy-s20-fe-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S20",
    "url": "/collections/galaxy-s20?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S10 Plus",
    "url": "/collections/galaxy-s10-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S10",
    "url": "/collections/samsung-galaxy-s10?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S10e",
    "url": "/collections/galaxy-s10e?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S9 Plus",
    "url": "/collections/for-samsung-galaxy-s9-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy S Series",
    "model": "Galaxy S9",
    "url": "/collections/samsung-galaxy-s9?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Fold Series",
    "model": "Galaxy Z Fold 8 Ultra",
    "url": "/collections/galaxy-z-fold-8-ultra?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Fold Series",
    "model": "Galaxy Z Fold 8",
    "url": "/collections/galaxy-z-fold-8?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Fold Series",
    "model": "Galaxy Z Fold 7",
    "url": "/collections/galaxy-z-fold-7?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Fold Series",
    "model": "Galaxy Z Fold 6",
    "url": "/collections/galaxy-z-fold-6?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Fold Series",
    "model": "Galaxy Z Fold 5",
    "url": "/collections/galaxy-z-fold-5?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Fold Series",
    "model": "Galaxy Z Fold 4",
    "url": "/collections/galaxy-z-fold-4?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Fold Series",
    "model": "Galaxy Z Fold 3",
    "url": "/collections/galaxy-z-fold-3?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Flip Series",
    "model": "Galaxy Z Flip 8",
    "url": "/collections/galaxy-z-flip-8?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Flip Series",
    "model": "Galaxy Z Flip 7 FE",
    "url": "/collections/galaxy-z-flip-7-fe?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Flip Series",
    "model": "Galaxy Z Flip 7",
    "url": "/collections/galaxy-z-flip-7?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Flip Series",
    "model": "Galaxy Z Flip 6",
    "url": "/collections/galaxy-z-flip-6?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Flip Series",
    "model": "Galaxy Z Flip 5",
    "url": "/collections/galaxy-z-flip-5?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Flip Series",
    "model": "Galaxy Z Flip 4",
    "url": "/collections/galaxy-z-flip-4?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy Z Flip Series",
    "model": "Galaxy Z Flip 3",
    "url": "/collections/galaxy-z-flip-3?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A73 5G",
    "url": "/collections/for-galaxy-a73-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A72",
    "url": "/collections/galaxy-a72?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A72 5G",
    "url": "/collections/galaxy-a72-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A70",
    "url": "/collections/samsung-galaxy-a70?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A57 5G",
    "url": "/collections/galaxy-a57-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A56 5G",
    "url": "/collections/galaxy-a56-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A55 5G",
    "url": "/collections/galaxy-a55-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A54 5G",
    "url": "/collections/for-galaxy-a54-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A53 5G",
    "url": "/collections/for-galaxy-a53-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A52 5G",
    "url": "/collections/galaxy-a52-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A52s",
    "url": "/collections/samsung-galaxy-a52s?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A42",
    "url": "/collections/galaxy-a42?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A37 5G",
    "url": "/collections/galaxy-a37-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A36 5G",
    "url": "/collections/galaxy-a36-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A35 5G",
    "url": "/collections/galaxy-a35-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A34 5G",
    "url": "/collections/for-galaxy-a34-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A33 5G",
    "url": "/collections/for-galaxy-a33-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A32 5G",
    "url": "/collections/galaxy-a12?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A30",
    "url": "/collections/samsung-galaxy-a30?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A27 5G",
    "url": "/collections/galaxy-a27-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A26 5G",
    "url": "/collections/galaxy-a26-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A25 5G",
    "url": "/collections/galaxy-a25-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A24 4G",
    "url": "/collections/for-galaxy-a24-4g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A23",
    "url": "/collections/galaxy-a23?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A22 4G",
    "url": "/collections/galaxy-a22-4g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A17 4G",
    "url": "/collections/galaxy-a17-4g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A17 5G",
    "url": "/collections/galaxy-a17-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A16 5G",
    "url": "/collections/galaxy-a16-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A15 5G",
    "url": "/collections/galaxy-a15-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A14 5G",
    "url": "/collections/for-galaxy-a14-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A13 4G",
    "url": "/collections/galaxy-a13-4g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A13 5G",
    "url": "/collections/galaxy-a13-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A12",
    "url": "/collections/galaxy-a12-1?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A05s",
    "url": "/collections/galaxy-a05s?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Samsung",
    "series": "Galaxy A Series",
    "model": "Galaxy A04s",
    "url": "/collections/galaxy-a04s?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 10 Series",
    "model": "Pixel 10",
    "url": "/collections/pixel-10?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 10 Series",
    "model": "Pixel 10 Pro",
    "url": "/collections/pixel-10-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 10 Series",
    "model": "Pixel 10 Pro Fold",
    "url": "/collections/pixel-10-pro-fold?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 10 Series",
    "model": "Pixel 10 Pro XL",
    "url": "/collections/pixel-10-pro-xl?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 9 Series",
    "model": "Pixel 9",
    "url": "/collections/pixel-9?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 9 Series",
    "model": "Pixel 9 Pro",
    "url": "/collections/pixel-9pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 9 Series",
    "model": "Pixel 9 Pro Fold",
    "url": "/collections/pixel-9-pro-fold?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 9 Series",
    "model": "Pixel 9 Pro XL",
    "url": "/collections/pixel-9pro-xl?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 8 Series",
    "model": "Pixel 8",
    "url": "/collections/pixel-8?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 8 Series",
    "model": "Pixel 8 Pro",
    "url": "/collections/pixel-8pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 7 Series",
    "model": "Pixel 7",
    "url": "/collections/pixel-7?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 7 Series",
    "model": "Pixel 7 Pro",
    "url": "/collections/pixel-7-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 7 Series",
    "model": "Pixel 7a",
    "url": "/collections/pixel-7a-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 6 Series",
    "model": "Pixel 6",
    "url": "/collections/google-pixel-6?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 6 Series",
    "model": "Pixel 6 Pro",
    "url": "/collections/google-pixel-6-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Google",
    "series": "Pixel 6 Series",
    "model": "Pixel 6a",
    "url": "/collections/pixel-6a?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Nothing",
    "series": "Nothing Phone",
    "model": "Nothing Phone",
    "url": "/collections/nothing-phone"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A98 5G",
    "url": "/collections/oppo-a98-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A96",
    "url": "/collections/oppo-a96?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A92",
    "url": "/collections/oppo-a92?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A80 5G",
    "url": "/collections/oppo-a80-5g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A79 5G",
    "url": "/collections/oppo-a79-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A78 4G",
    "url": "/collections/oppo-a78?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A78 5G",
    "url": "/collections/oppo-a78-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A74 5G",
    "url": "/collections/for-oppo-a74-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A72",
    "url": "/collections/oppo-a72?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A60",
    "url": "/collections/oppo-a60"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A60 5G",
    "url": "/collections/oppo-a60-5g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A58 4G",
    "url": "/collections/oppo-a58?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A58 5G",
    "url": "/collections/oppo-a58-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A54 5G",
    "url": "/collections/for-oppo-a54-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A54s",
    "url": "/collections/oppo-a54s?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A53",
    "url": "/collections/oppo-a53?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A53s",
    "url": "/collections/oppo-a53s?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A53s 5G",
    "url": "/collections/oppo-a53s-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A52",
    "url": "/collections/oppo-a52?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A38",
    "url": "/collections/oppo-a38?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A38 4G",
    "url": "/collections/oppo-a38-4g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A18",
    "url": "/collections/oppo-a18?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A18 4G",
    "url": "/collections/oppo-a18-4g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A17",
    "url": "/collections/oppo-a17?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A17 4G",
    "url": "/collections/oppo-a17-4g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A16s",
    "url": "/collections/oppo-a16s?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A6 5G",
    "url": "/collections/oppo-a6-5g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A6X 4G",
    "url": "/collections/oppo-a6x-4g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A6X 5G",
    "url": "/collections/oppo-a6x-5g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A5 4G/5G",
    "url": "/collections/oppo-a5-4g-5g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A5 Pro 5G",
    "url": "/collections/oppo-a5-pro-5g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO A Series",
    "model": "OPPO A5X 4G",
    "url": "/collections/oppo-a5x-4g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find X8 Pro",
    "url": "/collections/oppo-find-x8-pro"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find N6 5G",
    "url": "/collections/oppo-find-n6-5g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find X5",
    "url": "/collections/oppo-find-x5?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find X5 Lite",
    "url": "/collections/oppo-find-x5-lite?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find X5 Pro",
    "url": "/collections/oppo-find-x5-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find X3",
    "url": "/collections/oppo-find-x3?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find X3 Neo",
    "url": "/collections/oppo-find-x3-neo?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find X3 Pro",
    "url": "/collections/oppo-find-x3-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find N2 Flip",
    "url": "/collections/oppo-find-n2-flip?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Find Series",
    "model": "OPPO Find X2 Pro",
    "url": "/collections/oppo-find-x2-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 16 F",
    "url": "/collections/oppo-reno-16-f"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 16 Pro",
    "url": "/collections/oppo-reno-16-pro"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 15 F",
    "url": "/collections/oppo-reno-15-f"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 15 Pro",
    "url": "/collections/oppo-reno-15-pro"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 13 5G",
    "url": "/collections/oppo-reno-13-5g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 13 F 5G",
    "url": "/collections/oppo-reno-13-f-5g"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 11 F 5G",
    "url": "/collections/oppo-reno-11-f?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 10 5G",
    "url": "/collections/oppo-reno-10-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 8 Lite",
    "url": "/collections/for-oppo-reno-8lite?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OPPO",
    "series": "OPPO Reno Series",
    "model": "OPPO Reno 8 Pro",
    "url": "/collections/oppo-reno-8-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 12",
    "url": "/collections/oneplus-12"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 12R",
    "url": "/collections/oneplus-12r"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 11",
    "url": "/collections/oneplus-11"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 10 Pro",
    "url": "/collections/oneplus-10-pro"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 10T",
    "url": "/collections/oneplus-10t"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 9",
    "url": "/collections/oneplus-9"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 9 Pro",
    "url": "/collections/oneplus-9-pro"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 9R",
    "url": "/collections/oneplus-9r"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 8",
    "url": "/collections/oneplus-8"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 8T",
    "url": "/collections/oneplus-8t"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 7",
    "url": "/collections/oneplus-7"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 7 Pro",
    "url": "/collections/oneplus-7-pro"
  },
  {
    "category": "Phone",
    "brand": "OnePlus",
    "series": "OnePlus Series",
    "model": "OnePlus 6T",
    "url": "/collections/oneplus-6t"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto E Series",
    "model": "Moto E22i",
    "url": "/collections/moto-e22i?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto E Series",
    "model": "Moto E13",
    "url": "/collections/moto-e13?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto E Series",
    "model": "Moto E6",
    "url": "/collections/motorola-moto-e6?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto E Series",
    "model": "Moto E6 Plus",
    "url": "/collections/motorola-moto-e6-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G84 5G",
    "url": "/collections/moto-g84?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G82 5G",
    "url": "/collections/moto-g82-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G62 5G",
    "url": "/collections/moto-g62?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G60 5G",
    "url": "/collections/moto-g60-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G54 5G",
    "url": "/collections/moto-g54-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G51 5G",
    "url": "/collections/for-moto-g51-5g?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G32",
    "url": "/collections/for-moto-g32?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G22",
    "url": "/collections/moto-g22?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G14",
    "url": "/collections/moto-g14?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Moto G Series",
    "model": "Moto G 5G Plus",
    "url": "/collections/moto-g-5g-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Motorola Edge Series",
    "model": "Moto Edge 40",
    "url": "/collections/moto-edge-40?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Motorola Edge Series",
    "model": "Moto Edge 30",
    "url": "/collections/motorola-edge-30?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Motorola Edge Series",
    "model": "Moto Edge 30 Fusion",
    "url": "/collections/moto-edge-30-fusion?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Motorola Edge Series",
    "model": "Moto Edge 30 Neo",
    "url": "/collections/moto-edge-30-neo?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Motorola Edge Series",
    "model": "Moto Edge 30 Pro",
    "url": "/collections/motorola-edge-30-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Motorola Edge Series",
    "model": "Moto Edge 30 Ultra",
    "url": "/collections/moto-edge-30-ultra?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Motorola Edge Series",
    "model": "Moto Edge 20",
    "url": "/collections/moto-edge-20?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Motorola Edge Series",
    "model": "Moto Edge 20 Fusion",
    "url": "/collections/moto-edge-20-fusion?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Motorola Edge Series",
    "model": "Moto Edge 20 Pro",
    "url": "/collections/moto-edge-20-pro?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Older Motorola",
    "model": "Moto Razr 5G 2022",
    "url": "/collections/motorola-moto-razr-5g-2022?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Older Motorola",
    "model": "Moto G9 Play",
    "url": "/collections/moto-g9-play?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Older Motorola",
    "model": "Moto G9 Plus",
    "url": "/collections/moto-g9-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Older Motorola",
    "model": "Moto G8 Plus",
    "url": "/collections/moto-g8-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Older Motorola",
    "model": "Moto G8 Power Lite",
    "url": "/collections/moto-g8-power-lite?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Older Motorola",
    "model": "Moto G7",
    "url": "/collections/motorola-moto-g7?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Motorola",
    "series": "Older Motorola",
    "model": "Moto G7 Plus",
    "url": "/collections/motorola-moto-g7-plus?view=device-series"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia G42",
    "url": "/collections/nokia-g42"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia C32",
    "url": "/collections/nokia-c32"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia C31",
    "url": "/collections/for-nokia-c31"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia C30",
    "url": "/collections/nokia-c30"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia X30 5G",
    "url": "/collections/nokia-x30-5g"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia C21 Plus",
    "url": "/collections/nokia-c21-plus"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia G21",
    "url": "/collections/nokia-g21"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia G20",
    "url": "/collections/nokia-g20"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia X20",
    "url": "/collections/nokia-x20"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia XR20",
    "url": "/collections/nokia-xr20"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia C12",
    "url": "/collections/nokia-c12"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia G10",
    "url": "/collections/nokia-g10"
  },
  {
    "category": "Phone",
    "brand": "Nokia",
    "series": "Nokia",
    "model": "Nokia C01 Plus",
    "url": "/collections/nokia-c01-plus"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS ROG Phone Series",
    "model": "ASUS ROG 6",
    "url": "/collections/asus-rog-6"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS ROG Phone Series",
    "model": "ASUS ROG 6 Pro",
    "url": "/collections/asus-rog-6-pro"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS ROG Phone Series",
    "model": "ASUS ROG 5",
    "url": "/collections/asus-rog-5"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS ROG Phone Series",
    "model": "ASUS ROG 5 Pro",
    "url": "/collections/asus-rog-5-pro"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS ROG Phone Series",
    "model": "ASUS ROG 5 Ultimate",
    "url": "/collections/asus-rog-5-ultimate"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS ROG Phone Series",
    "model": "ASUS ROG 5s",
    "url": "/collections/asus-rog-5s"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS ROG Phone Series",
    "model": "ASUS ROG 5s Pro",
    "url": "/collections/asus-rog-5s-pro"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS ROG Phone Series",
    "model": "ASUS ROG 3",
    "url": "/collections/asus-rog-3"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS Zenfone Series",
    "model": "ASUS Zenfone 8 5G",
    "url": "/collections/asus-zenfone-8-5g"
  },
  {
    "category": "Phone",
    "brand": "ASUS",
    "series": "ASUS Zenfone Series",
    "model": "ASUS Zenfone 8 Flip",
    "url": "/collections/asus-zenfone-8-flip"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad",
    "model": "iPad 10th Gen 10.9 2022",
    "url": "/collections/ipad-10th-gen-10-9-2022"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad",
    "model": "iPad 9th Gen 10.2 2021",
    "url": "/collections/ipad-9th-gen-10-2-2021"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad",
    "model": "iPad 8th Gen 10.2 2020",
    "url": "/collections/ipad-8th-gen-10-2-2020"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad",
    "model": "iPad 7th Gen 10.2 2019",
    "url": "/collections/ipad-7th-gen-10-2-2019"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad",
    "model": "iPad 6th Gen 9.7 2018",
    "url": "/collections/ipad-6th-gen-9-7-2018"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad",
    "model": "iPad 5th Gen 9.7 2017",
    "url": "/collections/ipad-5th-gen-9-7-2017"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad Air",
    "model": "iPad Air 4th Gen 10.9 2020",
    "url": "/collections/ipad-air-4th-gen-10-9-2020"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad Mini",
    "model": "iPad Mini 6 2021",
    "url": "/collections/ipad-mini-6-2021"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad Pro",
    "model": "iPad Pro 11 2nd Gen 2020",
    "url": "/collections/ipad-pro-11-2nd-gen-2020"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad Pro",
    "model": "iPad Pro 11 2018",
    "url": "/collections/ipad-pro-11-2018"
  },
  {
    "category": "Tablet",
    "brand": "Apple",
    "series": "iPad Pro",
    "model": "iPad Pro 10.5",
    "url": "/collections/ipad-pro-10-5"
  },
  {
    "category": "Tablet",
    "brand": "Samsung",
    "series": "Galaxy Tab A Series",
    "model": "Galaxy Tab A11+",
    "url": "/collections/galaxy-tab-a11-plus?view=device-series"
  },
  {
    "category": "Tablet",
    "brand": "Samsung",
    "series": "Galaxy Tab S Series",
    "model": "Galaxy Tab S11",
    "url": "/collections/galaxy-tab-s11?view=device-series"
  },
  {
    "category": "Tablet",
    "brand": "Samsung",
    "series": "Galaxy Tab S Series",
    "model": "Galaxy Tab S11 Ultra",
    "url": "/collections/galaxy-tab-s11-ultra?view=device-series"
  },
  {
    "category": "Tablet",
    "brand": "Samsung",
    "series": "Galaxy Tab S Series",
    "model": "Galaxy Tab S10 FE",
    "url": "/collections/galaxy-tab-s10-fe?view=device-series"
  },
  {
    "category": "Tablet",
    "brand": "Samsung",
    "series": "Galaxy Tab S Series",
    "model": "Galaxy Tab S10 FE+",
    "url": "/collections/galaxy-tab-s10-fe-plus?view=device-series"
  },
  {
    "category": "Tablet",
    "brand": "Samsung",
    "series": "Galaxy Tab S Series",
    "model": "Galaxy Tab S10 Lite",
    "url": "/collections/galaxy-tab-s10-lite?view=device-series"
  },
  {
    "category": "Tablet",
    "brand": "Samsung",
    "series": "Galaxy Tab S Series",
    "model": "Galaxy Tab S10 Ultra 5G",
    "url": "/collections/galaxy-tab-s10-ultra-5g?view=device-series"
  },
  {
    "category": "Tablet",
    "brand": "Samsung",
    "series": "Galaxy Tab S Series",
    "model": "Galaxy Tab S10+ 5G",
    "url": "/collections/galaxy-tab-s10-plus-5g?view=device-series"
  },
  {
    "category": "Laptop",
    "brand": "Apple",
    "series": "MacBook Air",
    "model": "Macbook Air 15\"",
    "url": "/collections/macbook-air-15"
  },
  {
    "category": "Laptop",
    "brand": "Apple",
    "series": "MacBook Air",
    "model": "Macbook Air 13\"",
    "url": "/collections/macbook-air-13"
  },
  {
    "category": "Laptop",
    "brand": "Apple",
    "series": "MacBook Pro",
    "model": "MacBook Pro 16\"",
    "url": "/collections/macbook-pro-16"
  },
  {
    "category": "Laptop",
    "brand": "Apple",
    "series": "MacBook Pro",
    "model": "MacBook Pro 14\"",
    "url": "/collections/macbook-pro-14"
  },
  {
    "category": "Laptop",
    "brand": "Apple",
    "series": "MacBook Pro",
    "model": "MacBook Pro 13\"",
    "url": "/collections/macbook-pro-13"
  },
  {
    "category": "Laptop",
    "brand": "Microsoft",
    "series": "Surface Laptop",
    "model": "Surface Laptop 4",
    "url": "/collections/for-surface-laptop-4"
  },
  {
    "category": "Laptop",
    "brand": "Microsoft",
    "series": "Surface Laptop",
    "model": "Surface Laptop 3",
    "url": "/collections/for-surface-laptop-3"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch Series 11",
    "model": "Apple Watch Series 11 46mm",
    "url": "/collections/apple-watch-series-11-46mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch Series 11",
    "model": "Apple Watch Series 11 42mm",
    "url": "/collections/apple-watch-series-11-42mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch Series 10",
    "model": "Apple Watch Series 10 46mm",
    "url": "/collections/apple-watch-series-10-46mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch Series 10",
    "model": "Apple Watch Series 10 42mm",
    "url": "/collections/apple-watch-series-10-42mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch SE 3",
    "model": "Apple Watch SE 3 44mm",
    "url": "/collections/apple-watch-se-3-44mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch SE 3",
    "model": "Apple Watch SE 3 40mm",
    "url": "/collections/apple-watch-se-3-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch by Size",
    "model": "Apple Watch 49mm",
    "url": "/collections/apple-watch-ultra-49mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch by Size",
    "model": "Apple Watch 45mm",
    "url": "/collections/apple-watch-45mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch by Size",
    "model": "Apple Watch 44mm",
    "url": "/collections/apple-watch-44mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch by Size",
    "model": "Apple Watch 42mm",
    "url": "/collections/apple-watch-42mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch by Size",
    "model": "Apple Watch 41mm",
    "url": "/collections/apple-watch-41mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch by Size",
    "model": "Apple Watch 40mm",
    "url": "/collections/apple-watch-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch by Size",
    "model": "Apple Watch 38mm",
    "url": "/collections/apple-watch-38mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch Ultra",
    "model": "Apple Watch Ultra 2 49mm",
    "url": "/collections/apple-watch-ultra-2-49mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Apple",
    "series": "Apple Watch Ultra",
    "model": "Apple Watch Ultra 3 49mm",
    "url": "/collections/apple-watch-ultra-3-49mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 9 Series",
    "model": "Galaxy Watch 9 44mm",
    "url": "/collections/galaxy-watch-9-44mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 9 Series",
    "model": "Galaxy Watch 9 40mm",
    "url": "/collections/galaxy-watch-9-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 8 Series",
    "model": "Galaxy Watch 8 46mm",
    "url": "/collections/galaxy-watch-8-46mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 8 Series",
    "model": "Galaxy Watch 8 Classic 46mm",
    "url": "/collections/galaxy-watch-8-classic-46mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 8 Series",
    "model": "Galaxy Watch 8 44mm",
    "url": "/collections/galaxy-watch-8-44mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 8 Series",
    "model": "Galaxy Watch 8 40mm",
    "url": "/collections/galaxy-watch-8-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 7 Series",
    "model": "Galaxy Watch 7 44mm",
    "url": "/collections/galaxy-watch-7-44mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 7 Series",
    "model": "Galaxy Watch 7 40mm",
    "url": "/collections/galaxy-watch-7-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 6 Series",
    "model": "Galaxy Watch 6 Classic 47mm",
    "url": "/collections/galaxy-watch-6-classic-47mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 6 Series",
    "model": "Galaxy Watch 6 44mm",
    "url": "/collections/galaxy-watch-6-44mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 6 Series",
    "model": "Galaxy Watch 6 Classic 43mm",
    "url": "/collections/galaxy-watch-6-classic-43mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 6 Series",
    "model": "Galaxy Watch 6 40mm",
    "url": "/collections/galaxy-watch-6-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 5 Series",
    "model": "Galaxy Watch 5 Pro 45mm",
    "url": "/collections/galaxy-watch-5-pro-45mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 5 Series",
    "model": "Galaxy Watch 5 44mm",
    "url": "/collections/galaxy-watch-5-44mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 5 Series",
    "model": "Galaxy Watch 5 40mm",
    "url": "/collections/galaxy-watch-5-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 4 Series",
    "model": "Galaxy Watch 4 Classic 46mm",
    "url": "/collections/galaxy-watch-4-classic-46mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 4 Series",
    "model": "Galaxy Watch 4 44mm",
    "url": "/collections/galaxy-watch-4-44mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 4 Series",
    "model": "Galaxy Watch 4 Classic 42mm",
    "url": "/collections/galaxy-watch-4-classic-42mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch 4 Series",
    "model": "Galaxy Watch 4 40mm",
    "url": "/collections/galaxy-watch-4-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Earlier Galaxy Watch Models",
    "model": "Galaxy Watch 3 41/45mm",
    "url": "/collections/galaxy-watch-3-45mm-41mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Earlier Galaxy Watch Models",
    "model": "Galaxy Watch Active 2 44mm",
    "url": "/collections/galaxy-watch-active-2-44mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Earlier Galaxy Watch Models",
    "model": "Galaxy Watch Active 2 40mm",
    "url": "/collections/galaxy-watch-active-2-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Earlier Galaxy Watch Models",
    "model": "Galaxy Watch Active",
    "url": "/collections/galaxy-watch-active?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch FE",
    "model": "Galaxy Watch FE 40mm",
    "url": "/collections/galaxy-watch-fe-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch Ultra Series",
    "model": "Galaxy Watch Ultra (2025) 47mm",
    "url": "/collections/galaxy-watch-ultra-2025-47mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch Ultra Series",
    "model": "Galaxy Watch Ultra 2 47mm",
    "url": "/collections/galaxy-watch-ultra-2-47mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Samsung",
    "series": "Galaxy Watch Ultra Series",
    "model": "Galaxy Watch Ultra 47mm",
    "url": "/collections/galaxy-watch-ultra-47mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Google",
    "series": "Pixel Watch 5",
    "model": "Google Pixel Watch 5 45mm",
    "url": "/collections/google-pixel-watch-5-45mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Google",
    "series": "Pixel Watch 5",
    "model": "Google Pixel Watch 5 41mm",
    "url": "/collections/google-pixel-watch-5-41mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Google",
    "series": "Pixel Watch 4",
    "model": "Google Pixel Watch 4 45mm",
    "url": "/collections/google-pixel-watch-4-45mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Google",
    "series": "Pixel Watch 4",
    "model": "Google Pixel Watch 4 41mm",
    "url": "/collections/google-pixel-watch-4-41mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Google",
    "series": "Pixel Watch 3",
    "model": "Google Pixel Watch 3 45mm",
    "url": "/collections/google-pixel-watch-3-45mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Google",
    "series": "Pixel Watch 3",
    "model": "Google Pixel Watch 3 41mm",
    "url": "/collections/google-pixel-watch-3-41mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Google",
    "series": "Pixel Watch 2",
    "model": "Google Pixel Watch 2",
    "url": "/collections/google-pixel-watch-2?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Google",
    "series": "Pixel Watch",
    "model": "Google Pixel Watch",
    "url": "/collections/google-pixel-watch?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Xiaomi",
    "series": "Xiaomi Mi Band",
    "model": "Xiaomi Mi Band 7",
    "url": "/collections/xiaomi-mi-band-7?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Xiaomi",
    "series": "Xiaomi Mi Band",
    "model": "Xiaomi Mi Band 5/6",
    "url": "/collections/xiaomi-mi-band-5-6?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Xiaomi",
    "series": "Xiaomi Mi Band",
    "model": "Xiaomi Mi Band Accessories",
    "url": "/collections/xiaomi-mi-band-accessories?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 970",
    "url": "/collections/for-garmin-forerunner-970?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 955/Solar/965",
    "url": "/collections/for-garmin-forerunner-955-solar-965?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 965",
    "url": "/collections/for-forerunner-965?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 955",
    "url": "/collections/for-forerunner-955?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 955 Solar",
    "url": "/collections/for-forerunner-955-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 955/955 Solar",
    "url": "/collections/for-garmin-forerunner-955-955-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 735/935/945",
    "url": "/collections/for-garmin-forerunner-735-935-945?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 935/945",
    "url": "/collections/for-garmin-forerunner-935-945?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 945",
    "url": "/collections/for-garmin-forerunner-945?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 945 LTE",
    "url": "/collections/for-garmin-forerunner-945-lte?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 900 Series",
    "model": "Garmin Forerunner 935",
    "url": "/collections/for-garmin-forerunner-935?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 600–700 Series",
    "model": "Garmin Forerunner 745",
    "url": "/collections/for-garmin-forerunner-745?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 600–700 Series",
    "model": "Garmin Forerunner 735XT",
    "url": "/collections/for-garmin-forerunner-735xt?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 600–700 Series",
    "model": "Garmin Forerunner 645",
    "url": "/collections/for-forerunner-645?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 600–700 Series",
    "model": "Garmin Forerunner 645 Music",
    "url": "/collections/for-forerunner-645-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 600–700 Series",
    "model": "Garmin Forerunner 645/645 Music",
    "url": "/collections/for-garmin-forerunner-645-645-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 570 42mm",
    "url": "/collections/for-garmin-forerunner-570-42mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 570 47mm",
    "url": "/collections/for-garmin-forerunner-570-47mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 265",
    "url": "/collections/for-forerunner-265?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 265S",
    "url": "/collections/for-garmin-forerunner-265s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 255",
    "url": "/collections/for-garmin-forerunner-255?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 255 Music",
    "url": "/collections/for-garmin-forerunner-255-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 255S",
    "url": "/collections/for-garmin-forerunner-255s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 255S Music",
    "url": "/collections/for-garmin-forerunner-255s-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 245",
    "url": "/collections/for-forerunner-245?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 245 Music",
    "url": "/collections/for-forerunner-245-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 200–500 Series",
    "model": "Garmin Forerunner 245/245 Music",
    "url": "/collections/for-garmin-forerunner-245-245-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 100 & Earlier",
    "model": "Garmin Forerunner 165",
    "url": "/collections/for-garmin-forerunner-165?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 100 & Earlier",
    "model": "Garmin Forerunner 165 Music",
    "url": "/collections/for-garmin-forerunner-165-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 100 & Earlier",
    "model": "Garmin Forerunner 55",
    "url": "/collections/for-forerunner-55?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 100 & Earlier",
    "model": "Garmin Forerunner 45",
    "url": "/collections/for-forerunner-45?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Forerunner 100 & Earlier",
    "model": "Garmin Forerunner 45S",
    "url": "/collections/for-forerunner-45s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 8 Series",
    "model": "Garmin Fenix 8 Pro 51mm",
    "url": "/collections/for-garmin-fenix-8-pro-51mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 8 Series",
    "model": "Garmin Fenix 8 Solar 51mm",
    "url": "/collections/for-garmin-fenix-8-solar-51mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 8 Series",
    "model": "Garmin Fenix 8 Pro 47mm",
    "url": "/collections/for-garmin-fenix-8-pro-47mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 8 Series",
    "model": "Garmin Fenix 8 Solar 47mm",
    "url": "/collections/for-garmin-fenix-8-solar-47mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 8 Series",
    "model": "Garmin Fenix E 47mm",
    "url": "/collections/for-garmin-fenix-e-47mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 8 Series",
    "model": "Garmin Fenix 8 43mm",
    "url": "/collections/for-garmin-fenix-8-43mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7",
    "url": "/collections/for-garmin-fenix-7?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7 Pro",
    "url": "/collections/for-garmin-fenix-7-pro?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7 Pro Sapphire",
    "url": "/collections/for-garmin-fenix-7-pro-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7 Pro Sapphire Solar",
    "url": "/collections/for-garmin-fenix-7-pro-sapphire-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7 Pro Solar",
    "url": "/collections/for-garmin-fenix-7-pro-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7 Pro Solar/Sapphire",
    "url": "/collections/for-garmin-fenix-7-pro-solar-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7 Sapphire",
    "url": "/collections/r-for-garmin-fenix-7-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7 Sapphire Solar",
    "url": "/collections/for-garmin-fenix-7-sapphire-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7 Solar",
    "url": "/collections/for-garmin-fenix-7-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7S",
    "url": "/collections/for-garmin-fenix-7s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7S Pro Sapphire Solar",
    "url": "/collections/for-garmin-fenix-7s-pro-sapphire-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7S Pro Solar",
    "url": "/collections/for-garmin-fenix-7s-pro-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7S Pro Solar/Sapphire",
    "url": "/collections/for-garmin-fenix-7s-pro-solar-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7S Sapphire",
    "url": "/collections/for-garmin-fenix-7s-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7S Sapphire Solar",
    "url": "/collections/for-garmin-fenix-7s-sapphire-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7S Solar",
    "url": "/collections/for-garmin-fenix-7s-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7S/Solar/Sapphire",
    "url": "/collections/for-garmin-fenix-7s-solar-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7X",
    "url": "/collections/for-garmin-fenix-7x?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7X Pro Sapphire Solar",
    "url": "/collections/for-garmin-fenix-7x-pro-sapphire-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7X Pro Solar",
    "url": "/collections/for-garmin-fenix-7x-pro-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7X Pro Solar/Sapphire",
    "url": "/collections/for-garmin-fenix-7x-pro-solar-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7X Sapphire",
    "url": "/collections/for-garmin-fenix-7x-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7X Sapphire Solar",
    "url": "/collections/for-garmin-fenix-7x-sapphire-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 7 Series",
    "model": "Garmin Fenix 7X Solar",
    "url": "/collections/for-garmin-fenix-7x-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6",
    "url": "/collections/for-garmin-fenix-6?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6 Pro",
    "url": "/collections/for-garmin-fenix-6-pro?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6 Pro Sapphire",
    "url": "/collections/for-garmin-fenix-6-pro-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6 Pro Solar Edition",
    "url": "/collections/for-garmin-fenix-6-pro-solar-edition?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6 Sapphire",
    "url": "/collections/for-garmin-fenix-6-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6/6Pro",
    "url": "/collections/for-garmin-fenix-6-6pro?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6S",
    "url": "/collections/for-garmin-fenix-6s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6S Pro",
    "url": "/collections/for-garmin-fenix-6s-pro?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6S Pro Sapphire",
    "url": "/collections/for-garmin-fenix-6s-pro-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6S Pro Solar",
    "url": "/collections/for-garmin-fenix-6s-pro-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6S Sapphire",
    "url": "/collections/for-garmin-fenix-6s-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6S/6S Pro",
    "url": "/collections/for-garmin-fenix-6s-6s-pro?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6X",
    "url": "/collections/for-garmin-fenix-6x?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6X Pro",
    "url": "/collections/for-garmin-fenix-6x-pro?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6X Pro Sapphire",
    "url": "/collections/for-garmin-fenix-6x-pro-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6X Pro Solar",
    "url": "/collections/for-garmin-fenix-6x-pro-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6X Sapphire",
    "url": "/collections/for-garmin-fenix-6x-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6X Solar",
    "url": "/collections/garmin-fenix-6x-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 6 Series",
    "model": "Garmin Fenix 6X/6X Pro",
    "url": "/collections/garmin-fenix-6x-6x-pro?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 5 Series",
    "model": "Garmin Fenix 5",
    "url": "/collections/for-garmin-fenix-5?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 5 Series",
    "model": "Garmin Fenix 5/5 Plus",
    "url": "/collections/for-garmin-fenix-5-5-plus?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 5 Series",
    "model": "Garmin Fenix 5S",
    "url": "/collections/for-garmin-fenix-5s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 5 Series",
    "model": "Garmin Fenix 5S Plus",
    "url": "/collections/for-garmin-fenix-5s-plus?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 5 Series",
    "model": "Garmin Fenix 5S/5S Plus",
    "url": "/collections/for-garmin-fenix-5s-5s-plus?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 5 Series",
    "model": "Garmin Fenix 5X",
    "url": "/collections/for-garmin-fenix-5x?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 5 Series",
    "model": "Garmin Fenix 5X Plus",
    "url": "/collections/for-garmin-fenix-5x-plus?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Fenix 5 Series",
    "model": "Garmin Fenix 5X/5X Plus",
    "url": "/collections/garmin-fenix-5x-5x-plus?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu 4 Series",
    "model": "Garmin Venu 4 45mm",
    "url": "/collections/for-garmin-venu-4-45mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu 4 Series",
    "model": "Garmin Venu 4 41mm",
    "url": "/collections/for-garmin-venu-4-41mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 3 Series",
    "model": "Garmin Instinct 3 Solar 50mm",
    "url": "/collections/for-garmin-instinct-3-solar-50mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 3 Series",
    "model": "Garmin Instinct 3 Solar 45mm",
    "url": "/collections/for-garmin-instinct-3-solar-45mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 3 Series",
    "model": "Garmin Instinct E 45mm",
    "url": "/collections/for-garmin-instinct-e-45mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 3 Series",
    "model": "Garmin Instinct E 40mm",
    "url": "/collections/for-garmin-instinct-e-40mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu 3 Series",
    "model": "Garmin Venu 3",
    "url": "/collections/for-garmin-venu-3?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu 3 Series",
    "model": "Garmin Venu 3S",
    "url": "/collections/for-garmin-venu-3s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 2 Series",
    "model": "Garmin Instinct 2",
    "url": "/collections/for-garmin-instinct-2?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 2 Series",
    "model": "Garmin Instinct 2 Solar",
    "url": "/collections/for-garmin-instinct-2-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 2 Series",
    "model": "Garmin Instinct 2S",
    "url": "/collections/for-garmin-instinct-2s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 2 Series",
    "model": "Garmin Instinct 2S Series",
    "url": "/collections/for-garmin-instinct-2s-series?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 2 Series",
    "model": "Garmin Instinct 2S Solar",
    "url": "/collections/for-garmin-instinct-2s-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 2 Series",
    "model": "Garmin Instinct 2X Solar",
    "url": "/collections/for-garmin-instinct-2x-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 2 Series",
    "model": "Garmin Instinct 2X Solar/Tactical",
    "url": "/collections/for-garmin-instinct-2x-solar-tactical?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Instinct 2 Series",
    "model": "Garmin Instinct 2X/2X Solar",
    "url": "/collections/for-garmin-instinct-2x-2x-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu 2 Series",
    "model": "Garmin Venu 2",
    "url": "/collections/for-garmin-venu-2?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu 2 Series",
    "model": "Garmin Venu 2 Plus",
    "url": "/collections/for-garmin-venu-2-plus?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu 2 Series",
    "model": "Garmin Venu 2S",
    "url": "/collections/for-garmin-venu-2s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Earlier Garmin Instinct",
    "model": "Garmin Instinct",
    "url": "/collections/for-garmin-instinct?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Earlier Garmin Instinct",
    "model": "Garmin Instinct Dual Power",
    "url": "/collections/for-garmin-instinct-dual-power?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Earlier Garmin Instinct",
    "model": "Garmin Instinct Dual Power Surf",
    "url": "/collections/for-garmin-instinct-dual-power-surf?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Earlier Garmin Instinct",
    "model": "Garmin Instinct Solar",
    "url": "/collections/for-garmin-instinct-solar?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Earlier Garmin Instinct",
    "model": "Garmin Instinct Sports",
    "url": "/collections/for-garmin-instinct-sports?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Earlier Garmin Instinct",
    "model": "Garmin Instinct Tactical",
    "url": "/collections/for-garmin-instinct-tactical?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Earlier Garmin Instinct",
    "model": "Garmin Instinct Tide",
    "url": "/collections/for-garmin-instinct-tide?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Approach Series",
    "model": "Garmin Approach S62",
    "url": "/collections/for-garmin-approach-s62?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Approach Series",
    "model": "Garmin Approach S60",
    "url": "/collections/for-garmin-approach-s60?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Approach Series",
    "model": "Garmin Approach S42",
    "url": "/collections/for-garmin-approach-s42?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Approach Series",
    "model": "Garmin Approach S40",
    "url": "/collections/for-garmin-approach-s40?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Approach Series",
    "model": "Garmin Approach S12",
    "url": "/collections/for-garmin-approach-s12?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Descent Series",
    "model": "Garmin Descent Mk 2s",
    "url": "/collections/for-garmin-descent-mk-2s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Epix Series",
    "model": "Garmin Epix Pro (Gen 2) 51mm",
    "url": "/collections/for-garmin-epix-pro-gen-2-51mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Epix Series",
    "model": "Garmin Epix Pro (Gen 2) 51mm-Sapphire",
    "url": "/collections/for-garmin-epix-pro-gen-2-51mm-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Epix Series",
    "model": "Garmin Epix Pro (Gen 2) 47mm",
    "url": "/collections/for-garmin-epix-pro-gen-2-47mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Epix Series",
    "model": "Garmin Epix Pro (Gen 2) 47mm-Sapphire",
    "url": "/collections/for-garmin-epix-pro-gen-2-47mm-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Epix Series",
    "model": "Garmin Epix Pro (Gen 2) 42mm",
    "url": "/collections/for-garmin-epix-pro-gen-2-42mm?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Epix Series",
    "model": "Garmin Epix Pro (Gen 2) 42mm-Sapphire",
    "url": "/collections/for-garmin-epix-pro-gen-2-42mm-sapphire?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Epix Series",
    "model": "Garmin Epix Gen 2",
    "url": "/collections/for-garmin-epix-gen-2?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu SQ Series",
    "model": "Garmin Venu SQ 2",
    "url": "/collections/for-garmin-venu-sq-2?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu SQ Series",
    "model": "Garmin Venu SQ 2 Music",
    "url": "/collections/for-garmin-venu-sq-2-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu SQ Series",
    "model": "Garmin Venu SQ",
    "url": "/collections/for-garmin-venu-sq?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Venu SQ Series",
    "model": "Garmin Venu SQ Music",
    "url": "/collections/for-garmin-venu-sq-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive 6",
    "url": "/collections/for-garmin-vivoactive-6?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive 5",
    "url": "/collections/for-garmin-vivoactive-5?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive 4",
    "url": "/collections/for-garmin-vivoactive-4?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive 4S",
    "url": "/collections/for-garmin-vivoactive-4s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive 3",
    "url": "/collections/for-garmin-vivoactive-3?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive 3 Music",
    "url": "/collections/for-garmin-vivoactive-3-music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive 3/3Music",
    "url": "/collections/for-garmin-vivoactive-3-3music?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive 3/Sports",
    "url": "/collections/for-garmin-vivoactive-3-sports?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive",
    "url": "/collections/for-garmin-vivoactive?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivoactive Series",
    "model": "Garmin Vivoactive S",
    "url": "/collections/for-garmin-vivoactive-s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivomove & VivoFit",
    "model": "Garmin Vivomove 3",
    "url": "/collections/for-garmin-vivomove-3?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivomove & VivoFit",
    "model": "Garmin Vivomove 3/3 HR",
    "url": "/collections/for-garmin-vivomove-3-3-hr?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivomove & VivoFit",
    "model": "Garmin Vivomove 3S",
    "url": "/collections/garmin-vivomove-3s?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivomove & VivoFit",
    "model": "Garmin Vivomove HR",
    "url": "/collections/garmin-vivomove-hr?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivomove & VivoFit",
    "model": "Garmin Vivomove HR Sport",
    "url": "/collections/for-garmin-vivomove-hr-sport?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivomove & VivoFit",
    "model": "Garmin Vivomove Luxe/Sports/Style",
    "url": "/collections/for-garmin-vivomove-luxe-sports-style?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Garmin",
    "series": "Garmin Vivomove & VivoFit",
    "model": "Garmin Vivomove Trend",
    "url": "/collections/for-garmin-vivomove-trend?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Charge",
    "model": "Fitbit Charge 6",
    "url": "/collections/fitbit-charge-6?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Charge",
    "model": "Fitbit Charge 5",
    "url": "/collections/fitbit-charge-5?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Charge",
    "model": "Fitbit Charge 4",
    "url": "/collections/fitbit-charge-4?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Charge",
    "model": "Fitbit Charge 3",
    "url": "/collections/fitbit-charge-3?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Charge",
    "model": "Fitbit Charge 2",
    "url": "/collections/fitbit-charge-2"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Inspire",
    "model": "Fitbit Inspire 3",
    "url": "/collections/fitbit-inspire-3?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Inspire",
    "model": "Fitbit Inspire 2",
    "url": "/collections/fitbit-inspire-2?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Sense",
    "model": "Fitbit Sense 2",
    "url": "/collections/for-fitbit-sense-2?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Sense",
    "model": "Fitbit Sense",
    "url": "/collections/for-fitbit-sense?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Versa",
    "model": "Fitbit Versa 4",
    "url": "/collections/for-fitbit-versa-4?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Versa",
    "model": "Fitbit Versa 3",
    "url": "/collections/for-fitbit-versa-3?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Versa",
    "model": "Fitbit Versa 2",
    "url": "/collections/for-fitbit-versa-2?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Versa",
    "model": "Fitbit Versa",
    "url": "/collections/for-fitbit-versa?view=device-series"
  },
  {
    "category": "Smartwatch",
    "brand": "Fitbit",
    "series": "Fitbit Versa",
    "model": "Fitbit Versa Lite",
    "url": "/collections/for-fitbit-versa-lite?view=device-series"
  },
  {
    "category": "Audio",
    "brand": "Apple",
    "series": "AirPods",
    "model": "Airpods 3",
    "url": "/collections/airpods-3"
  },
  {
    "category": "Audio",
    "brand": "Apple",
    "series": "AirPods",
    "model": "AirPods Pro 2",
    "url": "/collections/airpods-pro-2nd"
  },
  {
    "category": "Audio",
    "brand": "Apple",
    "series": "AirPods",
    "model": "Airpods Max",
    "url": "/collections/airpods-max"
  },
  {
    "category": "Audio",
    "brand": "Apple",
    "series": "AirPods",
    "model": "AirPods Pro",
    "url": "/collections/airpods-pro"
  },
  {
    "category": "Audio",
    "brand": "Samsung",
    "series": "Galaxy Buds",
    "model": "Galaxy Buds Series",
    "url": "/collections/galaxy-buds-series"
  },
  {
    "category": "Audio",
    "brand": "Motorola",
    "series": "Moto Buds",
    "model": "Moto Buds+",
    "url": "/products/for-moto-buds-plus-case-cover-shockproof-silicone-soft-full-protective-au"
  },
  {
    "category": "Gaming",
    "brand": "Nintendo",
    "series": "Nintendo Switch",
    "model": "Nintendo Switch Accessories",
    "url": "/collections/nintendo"
  }
];
